export default __webpack_public_path__ + "static/N0132-8acc292cdbd5a646af7448bfe4a3b526.png";